<template>
  <div class="inline-flex items-center group cursor-pointer" @click="$emit('click')">
    <IconMoreSettings class="text-icon mr-4
                              group-hover:text-icon-hover transition duration-200"
                      :class="{'text-icon-hover':active}"/>
    <span class="text-sm text-text transition duration-200"
          :class="{'font-medium':active}">{{ text || $t('more_settings') }}</span>
  </div>
</template>

<script>
import IconMoreSettings from "@/components/icons/IconMoreSettings";

export default {
  name: "MoreSettings",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    text:{
      type:String,
      default:''
    }
  },
  components: {IconMoreSettings},
  i18n: {
    messages: {
      en: {
        more_settings: 'More settings'
      },
      ru: {
        more_settings: 'Дополнительные настройки'
      }
    }
  }
}
</script>

<style scoped>
.active {
  @apply text-icon-hover;
}

</style>